import { render } from "./datepicker.vue?vue&type=template&id=074b81ca"
import script from "./datepicker.vue?vue&type=script&lang=js"
export * from "./datepicker.vue?vue&type=script&lang=js"

import "./datepicker.vue?vue&type=style&index=0&id=074b81ca&lang=css"

import exportComponent from "/Users/haticeedis/Projects/vue-datepicker-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__